import * as React from 'react';
import Common from '../../utilities/common';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import $ from "jquery";
import { Box, Button, Chip, Grid, Paper, Typography } from '@mui/material';
import Layout from '../../components/Utilities/Layout';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import EntityPermissions from '../../components/EntityPermissions';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import StorageIcon from '@mui/icons-material/Storage';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';
import TrafficOutlinedIcon from '@mui/icons-material/TrafficOutlined';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import LightOutlinedIcon from '@mui/icons-material/LightOutlined';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import WomanIcon from '@mui/icons-material/Woman';
import ManIcon from '@mui/icons-material/Man';
import ProvinciaTotal from './ProvinciaTotal';

export interface IProvinciaDetailState {
    provincias: any[],
    selectedProvincia: string,
    comunidadAutonoma: string
}

export default class ProvinciaDetail extends React.Component<{}, IProvinciaDetailState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            provincias: [],
            selectedProvincia: Common.getUrlParam('p'),
            comunidadAutonoma: Common.getUrlParam('c')
        }
    }

    componentDidMount(): void {
        this.Getprovincias(Common.getUrlParam('p'));
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Comunidades autónomas',
                            url: '/summary/comunidadesautonomas'
                        },
                        {
                            title: 'Provincias',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <HomeWorkOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Provincia
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='main transparent'>
                        <Grid container spacing={3}>
                            <Grid item xs={3}>
                                <Paper elevation={3} sx={{padding: '20px 5px'}} square>
                                    <Box display={'flex'} justifyContent={'space-between'} margin={'0px 10px'} marginBottom={'10px'} sx={{borderBottom: 'solid 1px #ccc'}}>
                                        <Typography variant="body2" component="div" sx={{cursor: 'pointer'}}>
                                            Provincia
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            Nº Registros
                                        </Typography>
                                    </Box>
                                    {
                                        this.state.provincias.map((provincia: any, index: number) => {
                                            return (
                                                <Box display={'flex'} justifyContent={'space-between'} marginBottom={'10px'} padding={'2px 10px'} key={index} sx={{backgroundColor: this.state.selectedProvincia == provincia.provincia ? '#f4f4f4' : '#fff'}}>
                                                    <Typography variant="body2" component="div" sx={{cursor: 'pointer', position: 'relative', top: '5px'}} onClick={() => {
                                                        this.setState(
                                                            {
                                                                selectedProvincia: provincia.nombre
                                                            }
                                                        );

                                                        this.Getprovincias(provincia.nombre);
                                                    }}>
                                                        {
                                                            provincia.nombre
                                                        }
                                                    </Typography>
                                                    <Typography variant="body2" component="div">
                                                        <Chip label={provincia.total}/>
                                                    </Typography>
                                                </Box>
                                            )
                                        })
                                    }
                                </Paper>
                            </Grid>
                            <Grid item xs={9}>
                                <Grid container spacing={3}>
                                    {
                                        !Common.IsNullOrEmpty(this.state.selectedProvincia) && (
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <Paper elevation={3} square sx={{padding: '20px'}}>
                                                        <Typography variant='h5'>
                                                            {
                                                                `${decodeURIComponent(this.state.comunidadAutonoma)}: ${decodeURIComponent(this.state.selectedProvincia)}`
                                                            }
                                                        </Typography>
                                                    </Paper>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} field='' title='Total' icon={<StorageIcon style={{fontSize: '32px', opacity: '.5'}}/>}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} sexField={true} field='h' title='Hombres' icon={<ManIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true} chartColor={Common.MAN_BORDER_COLOR}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} sexField={true} field='m' title='Mujeres' icon={<WomanIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true} chartColor={Common.WOMAN_BORDER_COLOR}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} field='FechaNacimiento' title='Fechas de nacimiento' icon={<CakeOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} field='Telefono' title='Telefonos' icon={<LocalPhoneOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} field='email' title='Emails' icon={<AlternateEmailOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} field='NombreVia' title='Nombres de vía' icon={<SignpostOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} field='tipoVia' title='Tipos de vía' icon={<TrafficOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} field='provincia' title='provincias' icon={<HolidayVillageOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} field='provincia' title='Provincias' icon={<LocationCityOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} field='CupsLuz' title='CUPS Luz' icon={<LightOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ProvinciaTotal provincia={this.state.selectedProvincia} field='cupsLuz' title='CUPS Gas' icon={<LocalFireDepartmentOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                            </React.Fragment>
                                        )
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Layout>
            </SecurityTrimmer>
        )
    }

    private Getprovincias(provincia: string) {
        let url = `${Common.END_POINT}/charts/provincia/${provincia}/allprovincias`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    provincias: response
                }
            );
        })
    }
}